import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Lightbox from '../../partials/Lightbox';

export default class Add extends Component {
    state = {
        title: '',
        children: '',
        watt: '',
        co2_ton: '',
        co2_years: '',
		description: '',
		sales_title: '',
		sales_description: '',
		sales_image: '',
        show_on_website: false,
        errors: '',
        redirectToDashboard: false,
        lightbox: false
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.checkboxChange = this.checkboxChange.bind(this);
        this.submit = this.submit.bind(this);
        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    inputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    checkboxChange(event) {
        this.setState({ [event.target.name]: event.target.checked ? 1 : 0 });
    }

    submit(event) {
        event.preventDefault();
        var self = this;

        axios.post(API_URL+'/admin/projects', {
            title: this.state.title,
            children: this.state.children,
            watt: this.state.watt,
            co2_ton: this.state.co2_ton,
            co2_years: this.state.co2_years,
			description: this.state.description,
			show_on_website: this.state.show_on_website,
			sales_title: this.state.sales_title,
			sales_description: this.state.sales_description,
			sales_image: this.state.sales_image
        })
        .then(response => {
            self.setState({ redirectToDashboard: true });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                self.setState({ errors: error.response.data });
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                self.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    toggleLightbox() {
        this.setState({ lightbox: (this.state.lightbox === true ? false: true) });
    }

    render() {
        if (this.state.redirectToDashboard) {
            return (
                <Redirect to="/superadmin/app" message="Projektet har lagts till" />
            )
        }

        return (
            <div>
                <Lightbox open={ this.state.lightbox } toggle={ this.toggleLightbox } contents={ <div><h3>Exempel på hur texten används på ett gåvobevis</h3><hr /><p>Namn Namnsson</p><p>Bidrar genom sin investering i solcellsanläggningen på <strong>[projektets namn]</strong> till att <strong>[antal barn]</strong> barn får elektricitet via <strong>[antal watt]</strong>W solceller.</p><p>Bidraget kommer spara <strong>[antal ton co2]</strong>ton co2 under <strong>[antal år]</strong> år!</p></div> } />

                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>

                        <button className="lightbox-toggle" onClick={ this.toggleLightbox }></button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />

                <div className="container">
                    <div className="content">
                        <h1 className="m-bottom">Lägg till projekt</h1>

                        <form onSubmit={ this.submit }>
                            <label>Namn på projekt</label>
                            <input type="text" name="title" value={ this.state.title } onChange={ this.inputChange } />
                            <h3>Ange information till gåvobevis</h3>
                            <label>Hur många barn får hjälp?</label>
                            <input type="number" name="children" value={ this.state.children } onChange={ this.inputChange } />
                            <label>Wattstyrkan på solceller</label>
                            <input type="number" name="watt" value={ this.state.watt } onChange={ this.inputChange } />
                            <label>Antal ton co2 som sparas</label>
                            <input type="number" name="co2_ton" value={ this.state.co2_ton } onChange={ this.inputChange } />
                            <label>Under hur många år</label>
                            <input type="number" name="co2_years" value={ this.state.co2_years } onChange={ this.inputChange } />
							<label>Beskrivning</label>
							<textarea name="description" onChange={ this.inputChange } value={ this.state.description } />
							<h3>Information som visas i app för säljare</h3>
							<label>Rubrik</label>
							<input type="text" name="sales_title" value={ this.state.sales_title } onChange={ this.inputChange } />
							<label>Information om projektet</label>
							<textarea name="sales_description" onChange={ this.inputChange } value={ this.state.sales_description } />
							<label>Bild</label>
							<div>Länk till bild från webbplats. Tänk på storleken, ej högupplösta.</div>
							<input type="text" name="sales_image" value={ this.state.sales_image } onChange={ this.inputChange } />
							<input type="checkbox" name="show_on_website" value="1" checked={ this.state.show_on_website } onChange={ this.checkboxChange } /> Visa i registreringsformulär
							<input className="button purple" type="submit" value="Spara" />
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Project/Add.js